export default __webpack_public_path__ + "img/tab1-7afac0dd.png";